import { useState } from "react";
import { Modal, message } from "antd";
import BulkUploadEditor from "./BulkUploadEditor";
import StepOneMapping from "./StepOneMapping";
import { useSpin } from "../../../components/SpinContext";
import { useToken } from "../../../common/helper";
import { columnMatching } from "../../../api's/shipment";

const dummyColumns = [
  "ship_id",
  "proj_id",
  "carrier",
  "carrier_track",
  "sensor",
  "sensor_id",
  "prod",
  "prod_alt",
  "origin",
  "destination",
  "notes",
  "contact",
  "unit_type",
  "department",
];

const DataMappingModal = ({
  showMappingModal,
  setShowMappingModal,
  setFieldMappings,
  setModalOpen,
  fileKey,
  fieldMappings,
  unauthorize,
}) => {
  const [mapping, setMapping] = useState({});
  const [step, setStep] = useState(1);
  const { showSpin, hideSpin } = useSpin();
  const [fileData, setFileData] = useState([]);
  const { token, removeToken } = useToken();
  const [enabled, setEnabled] = useState(() =>
    Object.fromEntries(dummyColumns.map((col) => [col, true]))
  );

  const handleToggle = (index, checked) => {
    const field = fieldMappings[index];
    const updatedField = { ...field, enable: checked };

    setFieldMappings((prev) =>
      prev.map((f, i) => (i === index ? updatedField : f))
    );
  };

  const handleMappingChange = (index, newActualName) => {
    setFieldMappings((prev) =>
      prev.map((field, i) =>
        i === index ? { ...field, actual_name: newActualName } : field
      )
    );
  };

  const handleNext = () => {
    if (step === 1) {
      const cleanedPayload = {
        key: fileKey,
        mapping: fieldMappings
          .filter(
            (field) =>
              field.actual_name &&
              field.header_name &&
              field.actual_name.trim() !== "" &&
              field.header_name.trim() !== ""
          )
          .map((field) => ({
            header_name: field.header_name,
            actual_name: field.actual_name,
            enable: field.enable !== false,
          })),
      };

      showSpin();
      columnMatching(token, cleanedPayload)
        .then((res) => {
          const data = res?.data?.data || null;
          if (data?.is_success) {
            message.success(data?.message);

            setFileData(data?.data);
            setStep(2);
          } else {
            message.error(
              data?.message || "Submission failed. Please try again."
            );
          }
        })
        .catch((error) => {
          unauthorize(error);
          message.error("Submission failed. Please try again.");
        })
        .finally(() => {
          hideSpin();
        });
    } else {
      setShowMappingModal(false);
    }
  };

  return (
    <Modal
      title=""
      centered
      open={showMappingModal}
      onCancel={() => {
        setShowMappingModal(false);
        setStep(1);
      }}
      width="90%"
      footer={null}
      styles={{ content: { borderRadius: "18px", overflow: "hidden" } }}
    >
      {step === 1 ? (
        <StepOneMapping
          mapping={mapping}
          setMapping={setMapping}
          fieldMappings={fieldMappings}
          onCancel={() => {
            setModalOpen(false);
            setShowMappingModal(false);
            setStep(1);
          }}
          onNext={handleNext}
          dummyColumns={dummyColumns}
          enabled={enabled}
          handleToggle={handleToggle}
          handleMappingChange={handleMappingChange}
        />
      ) : (
        <BulkUploadEditor
          fileData={fileData}
          onCancel={() => {
            setModalOpen(false);
            setShowMappingModal(false);
            setStep(1);
          }}
          totalShipments={328}
          totalRecords={409}
          unauthorize={unauthorize}
          onBackToStep1={() => setStep(1)}
        />
      )}
    </Modal>
  );
};

export default DataMappingModal;
